import React from 'react'
import './Aside.sass'
import {NavLink} from "react-router-dom"

export default () => {
  return (
    <React.Fragment>
      <aside className='aside'>
        <div className="aside-title">
          <h2>АИС ТПП</h2>
        </div>
        <div className="aside-point">
          <NavLink
            activeClassName='aside-point__active'
            to='/modules/input/blank'
            className="aside-point__item"
          >Ввод исходных данных заготовки</NavLink>
          <NavLink
            activeClassName='aside-point__active'
            to='/modules/input/details'
            className="aside-point__item"
          >Ввод исходных данных детали</NavLink>
          <NavLink
            activeClassName='aside-point__active'
            to='/modules/road'
            className="aside-point__item"
          >Маршрут обработки</NavLink>
          <NavLink
            activeClassName='aside-point__active'
            to='/modules/polishing/start'
            className="aside-point__item"
          >Шлифовальные круги</NavLink>
          <NavLink
            activeClassName='aside-point__active'
            to='/modules/mode/start'
            className="aside-point__item"
          >Режимы резания</NavLink>
          <NavLink
            activeClassName='aside-point__active'
            to='/modules/method'
            className="aside-point__item"
          >Шлифовальные станки</NavLink>
        </div>
      </aside>
    </React.Fragment>
  )
}